export const InvestmentType = {
  TOTAL: 'TOTAL',
  TOTAL_REPROGRAMMED: 'TOTAL_REPROGRAMMED',
  TOTAL_ELIGIBLE: 'TOTAL_ELIGIBLE',

  values: () => {
    return ['TOTAL', 'TOTAL_REPROGRAMMED', 'TOTAL_ELIGIBLE'];
  }
};
